import React, { Component } from 'react';
import { Button, Form, Input, Select, Space, Radio,Cascader,message,Row,Col,Checkbox,Modal,Upload  } from 'antd';
import { Link } from "react-router-dom";
import { request } from "utils.js";
import IndexModal from "./indexModel";
import registerIcon from "static/img/registlogo3.png";
import HideModel from "./hideModel";
import "./index.less";
const S4=() =>{
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
const GenUuid=()=> {
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}
const imgNunCode = GenUuid()
class RegisterContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyType:[],
      addressList:[],
      industryCategoryEnum: [],
      initialValues:{},
      fangshi:1,
      numTime:0,
      showModal:false,
      showCon:true,
      successTime:0,
      showHideModal:false,
      imgUrl:'/aiprt-basedata-register-be/register/imgcode?img_id=' + imgNunCode + '&reload=' + (new Date()).getTime(),
    };
    this.formRef = React.createRef();
  };
  
  componentDidMount() {
    request({
      method: 'get',
      url: `/aiprt-basedata-register-be/register/unittype`,
    }).then(res => {
      this.setState({
        companyType:res
      })
    });
    request({
      method: 'get',
      url: `/aiprt-basedata-register-be/register/address`,
    }).then(res => {
      this.setState({
        addressList:res
      })
    });
    request({
      method: 'POST',
      url: `/aiprt-project-init-be/project/queryEnum`,
      data: {
        enumCode: "industryCategory",
        appCode: "aiprtprojectinitiationapp"
      }
    }).then(res => {
      this.setState({
        industryCategoryEnum: res?.map(item=>({value: item?.code, label: item?.name}))
      })
    });

    
    // // 即时函数
    (() => {
      let that = this
      const sessionData = Number(sessionStorage.getItem('numTime'));
      const nowTime = new Date().getTime()
      if(sessionData > nowTime){
        const shengyu = sessionData/1000 - nowTime/1000
        that.setState({numTime:Math.floor(shengyu)})
        let timer = setInterval(function () {
          let num = that.state.numTime - 1
          that.setState({numTime:num })
          if (num <= 0) {
           clearInterval(timer);
          }
        }, 1000);
      }else{
        sessionStorage.clear('numTime')
      }
    })();
  }
  
  handleSubmit=(e)=>{
    let that = this
    const form = this.formRef.current;
    const values = form.getFieldsValue([
      'account',//用户名
      'certno',//证件号码
      "certtype", // 证件类型
      "registerarea",// 收件地址
      "receiveaddress", // 收件地址
      "contacter", // 联系人
      "email", // yangping_198910@163.com
      "imgCode", // 图形验证码
      "confirmPwd", // 确认密码
      'password',//密码
      'phone',//手机号码
      'smsCode',//手机验证码
      "name", // 名称
      "creditcode", // 信用代码
      "unittype", // 单位类型
      "belongIndustry"  //  所属行业
    ])
    values["imgCodeId"] = imgNunCode;
    values["registertype"] = 3;
    values["suppliertype"] = 1;
    values["registerarea"] = values.registerarea[values.registerarea.length-1];
    values["unittype"] = values.unittype[values.unittype.length-1];
    values["enterprise_name"] = values.name;
    values['is_agree'] = 'on'
    request({
      url: '/aiprt-basedata-register-be/register/save',
      method: 'post',
      data: values,
    }).then((res) => {
      this.setState({showCon:false, successTime:10})
      sessionStorage.clear('numTime')
      let successTimer = setInterval(function () {
        let num = that.state.successTime - 1
        that.setState({successTime:num })
        if (num <= 0) {
         clearInterval(successTimer);
        }
      }, 1000);
      setTimeout(function() {
        clearInterval(this.successTimer);
        window.location.href = '/'
      }, 100000);
    })
  }
  
  render() {
    let { initialValues,companyType,addressList,industryCategoryEnum,imgUrl,numTime,showModal,showCon,successTime,fangshi,showHideModal} = this.state;
    const form = this.formRef.current;
    //短信发送
    let that = this;
    
    const smsCodeBtn =(e)=>{
      e.preventDefault();
      const phoneValues = form.getFieldsValue([
        'phone',
      ])
      if(phoneValues.phone != '' && phoneValues.phone != null){
        request({
          method: 'get',
          url: `/aiprt-basedata-register-be/register/smscode?mobile=${phoneValues.phone}`,
        }).then(res => {
          if(!res){
            message.success('短信发送成功,请到手机上查看');
            this.setState({numTime:120 })
            let timer = setInterval(function () {
              let num = that.state.numTime -1
              that.setState({numTime:num })
              console.log(num)
              if (num <= 0) {
                clearInterval(timer);
              }
            }, 1000);
            let nowTime = new Date().getTime()//读取当前时间
            let endTime = 120000 + nowTime
            sessionStorage.setItem('numTime', endTime);
          }else{
            message.error(res);
          }
        });
      }else{
        message.error('请输入正确手机号码');
      }
    }
    const imgClick=()=>{
      this.setState({
        imgUrl:'/aiprt-basedata-register-be/register/imgcode?img_id=' + imgNunCode + '&reload=' + (new Date()).getTime(),
      })
    }
    const closeModal =()=>{
      this.setState({showModal:false})
    }
    const openModel =()=>{
      this.setState({showModal:true})
    }
    const handleSelectChange=(e)=>{
      this.setState({fangshi:e.target.value})
    }
    const props = {
      name: 'file',
      action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
      headers: {
        authorization: 'authorization-text',
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
    };
    
    return (
      <>
        <div className="registerleft">
          <div className='registText'>
            <div className='registText-con'>
              <div><img src={registerIcon} /></div>
              <h3>公平<i></i>公正<i></i>公开</h3>
              <p><i>公共资源数智采平台</i>升级数字底座、深耕行业、加速交易平台创新</p>
              <Link to="/">前往首页</Link><a onClick={() => {
                sessionStorage.setItem('afterLogin', location.href)
                location.href = 'https://aiprt.aipuret.cn/portal-notice/#/login?redirect=https://aiprt.aipuret.cn/aiprt-bid-opening-be/aiprt/login/userredirect'
              }} style={{cursor: 'pointer'}} >已有账号，请登录</a>
            </div>
          </div>
          {showCon == true ? 
            '':<div className="successRegist">
              <div className="successRegist-img"></div>
              <h3>登记成功，请等待十分钟后再登录!</h3>
              <p>欢迎您的加入公共资源数智采平台</p>
              <Link to="/">前往首页</Link>
            </div>
          }
          <div className="registerleft-con" style={{display:showCon?'':'none'}}>
            <h3>供应商登记</h3>
            {/* <div className='supplyFangshi'>
              <div>注册方式：</div>
              <div>
                <Radio.Group onChange={handleSelectChange} defaultValue={1}>
                  <Radio value={1}>新注册企业</Radio>
                  <Radio value={2}>加入企业</Radio>
                </Radio.Group>
                {fangshi == 2? <div className='tips'>"加入企业"是在企业管理员未知情况下，提供所需材料由平台管理员对企业管理员进行变更；（营业执照+企业授权书加盖公章）<a href='#'>材料模版</a></div>:''}
              </div>
            </div> */}
            <Form
              ref={this.formRef}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              initialValues={initialValues}
              onFinish={this.handleSubmit}
            >
              
              <Form.Item name="name" label="企业（单位）名称" 
                rules={[
                  { required: true, message: "必填，请输入", },
                ]}>
                <Input placeholder="请输入营业执照（机构登记证）全称，否则会影响正常业务办理！" />
              </Form.Item>
              <Form.Item name="creditcode" label="统一社会信用代码" 
                rules={[
                  { required: true, message: "必填，请输入", },
                  {
                    pattern: /^[A-Za-z0-9]+$/,
                    message: "请输入正确的统一社会信用代码",
                    trigger: 'blur'
                  }
                ]}>
                <Input placeholder="请输入统一社会信用代码（非内地主体请填写地方政策主体代码）" />
              </Form.Item>
              <Form.Item name="belongIndustry" label="所属行业" 
                rules={[
                  { required: true, message: "必填，请输入", },
                ]}>
                <Select options={industryCategoryEnum}  placeholder="请选择" />
              </Form.Item>
              {fangshi != 2?<>
              <Form.Item name="account" label="用户名" 
                rules={[
                  { required: true, message: "必填，请输入", },
                  {
                    pattern: /^[a-zA-Z0-9]{6,12}$/,
                    message: "请输入由字母、数字组成,且长度为6至12位的用户名",
                    trigger: 'blur'
                  },
                  {
                    pattern: /.*[a-zA-Z].*/,
                    message: "用户名须有字母，不能为纯数字",
                    trigger: 'blur'
                  },
                ]}>
                <Input placeholder="请设置用户名,必需由字母、数字组成,且长度为6至12位" />
              </Form.Item>
              <Form.Item
                name="password"
                label="密码"
                rules={[
                  {
                    required: true,
                    message: '必填，请输入',
                  },
                  {
                    pattern: /^((?!_).)*$/,
                    message: "密码不能输入下划线 _",
                    trigger: 'blur'
                  },
                  {
                    pattern: /^((?!@).)*$/,
                    message: "密码不能输入@",
                    trigger: 'blur'
                  },
                  {
                    pattern: /^(?!.*[\uff01\uffe5\uff08\uff09\uff1f]).*/,
                    message: "密码不能输入中文符号（！￥（）？）",
                    trigger: 'blur'
                  },
                  {
                    max:12,
                    message: "密码不能大于12位",
                    trigger: 'blur'
                  },
                  {
                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!#$%^&*()+-])[\w!#$%^&*()+-]{8,}$/,
                    message: "必须含大小写字母、数字、特殊符号（!#$%^&*()+-），最小长度8位",
                    trigger: 'blur'
                  },
                ]}
                hasFeedback
              >
                <Input.Password placeholder="密码最小8位,必需包含:数字、大小写字母、特殊字符!" />
              </Form.Item>
              <Form.Item
                name="confirmPwd"
                label="确认密码"
                dependencies={['password']}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: '必填，不能为空',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('两次密码不一致,请核对'));
                    },
                  }),
                ]}>
                <Input.Password placeholder="请再次输入密码" />
              </Form.Item>
              </>:''}
              <Form.Item name="email" label="邮箱" 
                rules={[
                  { required: true, message: "邮箱，用于接收相关信息", },
                  {
                    type: 'email',
                    message: "请输入正确邮箱",
                    trigger: 'blur'
                  }
                ]}>
                <Input placeholder="邮箱，用于接收相关信息" />
              </Form.Item>
              <Form.Item name="contacter" label="法人姓名" 
                rules={[
                  { required: true, message:"必填，请输入法人姓名", },
                  {
                    pattern: /^[a-zA-Z\u4E00-\u9FA5]+$/,
                    message: "仅限输入汉字与字母",
                    trigger: 'blur'
                  }
                ]}>
                <Input placeholder="请输入法人姓名" />
              </Form.Item>
              {fangshi != 2?
              <Form.Item name="receiveaddress" label="联系地址" 
                rules={[{ required: true, message: "联系地址不能为空", },]}>
                <Input placeholder="请输入收件地址" />
              </Form.Item>
              :''}
              <Form.Item name="phone" label="手机号" rules={[
                { required: true, message: "手机号不能为空", },
                {
                  pattern: /^1[3-9]\d{9}$/,
                  message: "请输入正确手机号码",
                  trigger: 'blur'
                }
              ]}>
                <Input placeholder="请输入正确手机号码" />
              </Form.Item>
              <Form.Item label="验证码">
                <Row gutter={8}>
                  <Col style={{width:'calc(100% - 110px)'}}>
                    <Form.Item
                      name="imgCode"
                      noStyle
                      rules={[
                        { required: true, message: "验证码不能为空", },
                        {
                          pattern: /^[A-Za-z0-9]+$/,
                          message: "仅能输入字母与数字",
                          trigger: 'blur'
                        },
                        {
                          max:4,
                          message: "图形验证码为4位",
                          trigger: 'blur'
                        },
                      ]}>
                      <Input name="imgCode" placeholder="请输入右侧图形验证码" />
                    </Form.Item>
                  </Col>
                  <Col className='clickimg'>
                  <img src={imgUrl} onClick={imgClick}   />
                  </Col>
                </Row>
              </Form.Item>
              <Form.Item label="短信验证码">
                <Row gutter={8}>
                  <Col style={{width:'calc(100% - 160px)'}}>
                    <Form.Item
                      name="smsCode"
                      noStyle
                      rules={[
                        { required: true, message: "短信验证码不能为空", },
                        {
                          pattern: /^[0-9]+$/,
                          message: "仅限输入数字",
                          trigger: 'blur'
                        },
                        {
                          max:6,
                          message: "验证码为六位数字",
                          trigger: 'blur'
                        },
                      ]}>
                      <Input placeholder="请输入短信验证码" />
                    </Form.Item>
                  </Col>
                  <Col>
                    {numTime>0?<Button type="primary" style={{width:'150px',height:'40px'}} disabled>（{numTime}）获取验证码</Button>:
                    <Button type="primary" style={{width:'150px',height:'40px'}} onClick={smsCodeBtn}>获取验证码</Button>
                    }
                  </Col>
                </Row>
              </Form.Item>
              {fangshi != 2?<>
              <Form.Item name="registerarea" label="登记地区" 
                rules={[
                  { required: true, message: "登记地区不能为空", }
                ]}>
                <Cascader options={addressList} showSearch placeholder="可搜索关键字" />
              </Form.Item>
              <Form.Item name="unittype" label="单位类型" 
                rules={[
                  { required: true, message: "单位类型不能为空", }
                ]}>
                <Cascader options={companyType}  placeholder="请选择" />
              </Form.Item>
              </>:''}
              {fangshi == 2?<>
              <Form.Item name="registerarea" label="授权文件" 
                rules={[
                  { required: true, message: "登记地区不能为空", }
                ]}>
                <Upload {...props}>
                  <Button>上传资料</Button>
                </Upload>
              </Form.Item>
              </>:''}
              <Form.Item className='bottomBoxWidth' label="."
                name="platServiceAgreement"
                valuePropName="checked"
                rules={[
                  {
                    validator: (_, value) =>
                      value ? Promise.resolve() : Promise.reject(new Error('请勾选《平台服务协议》,《用户协议及隐私政策》')),
                  },
                ]}
              >
                <Checkbox>
                我已阅读并理解  <a onClick={openModel}>《平台服务协议》</a><a onClick={()=>{this.setState({showHideModal:true})}}>《用户协议及隐私政策》</a>
                </Checkbox>
              </Form.Item>
              <Form.Item className='bottomBoxWidth' label=".">
                <Button type="primary" htmlType="submit" style={{ width: "100%", height: "46px" }}>
                  登记
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
        <Modal
          title={"公共资源交易全流程电子化系统平台（AIPRT）外部用户协议"}
          open={showModal}
          onOk={closeModal}
          onCancel={closeModal}
          width={1200}
          footer={[
            <Button type="primary" onClick={closeModal}>
              关闭
            </Button>,
          ]}
        >
          <IndexModal />
        </Modal>
        <Modal
          title={"公共资源数智采平台用户协议及隐私政策"}
          open={showHideModal}
          onOk={closeModal}
          style={{ top:'5%', bottom:'10%' }}
          onCancel={()=>{this.setState({showHideModal:false})}}
          width={1200}
          footer={[
            <Button type="primary" onClick={()=>{this.setState({showHideModal:false})}}>
              关闭
            </Button>,
          ]}
        >
          <HideModel />
        </Modal>
      </>
    );
  }
}

export default RegisterContent;